import "./dashboard-sections.css";

/**
 * DashboardCard — reusable card with consistent themed header.
 * Props:
 *   title     — card header text
 *   icon      — optional JSX icon shown on the right of header
 *   children  — card body content
 *   className — optional extra class on the wrapper
 */
const DashboardCard = ({ title, icon, children, className = "" }) => (
  <div className={`cmn_card db-card ${className}`}>
    <div className="db-card-header">
      <span className="db-card-header-title">{title}</span>
      {icon && <span className="db-card-header-icon">{icon}</span>}
    </div>
    <div className="db-card-body">
      {children}
    </div>
  </div>
);

export default DashboardCard;
